import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const CLINICAL_MIX_TREATMENT_PROFILE_FILTERS = REPORTS_DEFAULT_FILTERS

export const CLINICAL_MIX_TREATMENT_PROFILE_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'count' | 'percent'
}> = [
  {
    id: 'total-procedures',
    title: 'Total Procedures',
    footer: 'All completed procedures',
    format: 'count',
  },
  {
    id: 'crown-percentage',
    title: 'Crown Percentage',
    footer: 'Share of crowns',
    format: 'percent',
  },
  {
    id: 'srp-percentage',
    title: 'SRP Percentage',
    footer: 'Share of SRPs',
    format: 'percent',
  },
  {
    id: 'high-value-procedure-percentage',
    title: 'High-value Procedure Percentage',
    footer: 'Share of high-value procedures',
    format: 'percent',
  },
]
